import { createFileRoute } from '@tanstack/react-router'
import { ContactPage } from '@/pages/ContactPage'

const ContactRoute = () => {
  return <ContactPage />
}

export const Route = createFileRoute('/contact-us')({
  component: ContactRoute,
})
